import { ReactElement } from 'react';
import { isNull } from 'lodash';

import { CurrentUserIntegrationProfileQuery, IntegrationProfile } from '@dreryk/egabinet-adamed-expert-frontend-api';
import { CurrentPractitionerQuery, PractitionerDetails } from '@dreryk/egabinet-personnel-frontend-api';

import { useCqrsFind, useCqrsGet } from '@dreryk/command-query-react-common';
import { commonTranslationKeys } from '@dreryk/react-common';
import { LoaderSpinner, Message, MessageType } from '@dreryk/react-components';

type AdamedExpertAuthenticateModalLoaderRenderProps = {
   integrationProfile: IntegrationProfile;
};

type AdamedExpertAuthenticateModalLoaderProps = {
   children: (renderProps: AdamedExpertAuthenticateModalLoaderRenderProps) => ReactElement;
};

export const AdamedExpertAuthenticateModalLoader = (props: AdamedExpertAuthenticateModalLoaderProps): ReactElement => {
   const {
      data: currentUserIntegrationProfile,
      loading: currentUserIntegrationProfileLoading,
      error: currentUserIntegrationProfileError,
   } = useCqrsFind<IntegrationProfile>(() => new CurrentUserIntegrationProfileQuery());

   const {
      data: practitionerDetails,
      loading: practitionerDetailsLoading,
      error: practitionerDetailsError,
   } = useCqrsGet<PractitionerDetails>(() => new CurrentPractitionerQuery(), {
      enabled: isNull(currentUserIntegrationProfile),
   });

   if (currentUserIntegrationProfileLoading || practitionerDetailsLoading) {
      return <LoaderSpinner />;
   }

   if (currentUserIntegrationProfileError || practitionerDetailsError) {
      return (
         <Message
            testId={'currentUserIntegrationProfileFetchError'}
            type={MessageType.NEGATIVE}
            label={commonTranslationKeys.unexpectedErrorHasOccurred}
            displayIndicator
         />
      );
   }
   return props.children({
      integrationProfile: currentUserIntegrationProfile || {
         emailAddress: practitionerDetails.emailAddress,
         rememberMe: true,
      },
   });
};
